<template>
  <figure class="pdf-page" :style="{ width: layout.width + 'px' }">
    <div class="paper" :style="{ height: layout.height + 'px' }" :aria-busy="!ready && !error">
      <canvas ref="canvas" :style="{ width: layout.width + 'px', height: layout.height + 'px' }" role="img" :aria-label="'处方第 ' + page.pageNumber + ' 页'"></canvas>
      <div v-if="!ready" class="page-placeholder" role="status">
        <template v-if="error">
          <span>此页加载失败</span>
          <el-button type="text" @click="renderPage">重新加载</el-button>
        </template>
        <span v-else>正在加载第 {{page.pageNumber}} 页…</span>
      </div>
    </div>
    <figcaption>第 {{page.pageNumber}} 页 / 共 {{pageCount}} 页</figcaption>
  </figure>
</template>

<script>
import { canvasLayout } from '@/js/pdf-preview'

export default {
  props: {
    page: { type: Object, required: true },
    pageCount: { type: Number, required: true },
    availableWidth: { type: Number, required: true },
    zoom: { type: Number, required: true }
  },
  data() {
    return { visible: false, ready: false, error: false }
  },
  computed: {
    layout() {
      const viewport = this.page.getViewport({ scale: 1 })
      return canvasLayout(viewport.width, viewport.height, this.availableWidth, this.zoom, window.devicePixelRatio)
    }
  },
  mounted() {
    this._renderVersion = 0
    if (window.IntersectionObserver) {
      this._observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting
      }, { rootMargin: '500px 0px' })
      this._observer.observe(this.$el)
    } else {
      this.visible = true
    }
  },
  watch: {
    visible: 'renderPage',
    layout: 'renderPage'
  },
  beforeDestroy() {
    this._disposed = true
    this._renderVersion++
    if (this._observer) this._observer.disconnect()
    if (this._renderTask) this._renderTask.cancel()
    const canvas = this.$refs.canvas
    Promise.resolve(this._renderPromise).then(() => { canvas.width = 0; canvas.height = 0 })
  },
  methods: {
    renderPage() {
      const version = ++this._renderVersion
      this.ready = false
      this.error = false
      if (this._renderTask) this._renderTask.cancel()
      // Wait for cancellation before reusing the same canvas for the next zoom level.
      this._renderPromise = Promise.resolve(this._renderPromise).then(() => {
        if (this._disposed || version !== this._renderVersion) return
        const canvas = this.$refs.canvas
        if (!this.visible) {
          canvas.width = 0
          canvas.height = 0
          return
        }
        const layout = this.layout
        canvas.width = layout.pixelWidth
        canvas.height = layout.pixelHeight
        const task = this.page.render({
          canvasContext: canvas.getContext('2d'),
          viewport: this.page.getViewport({ scale: layout.scale }),
          transform: [layout.outputScale, 0, 0, layout.outputScale, 0, 0],
          background: '#ffffff'
        })
        this._renderTask = task
        return task.promise.then(() => {
          if (!this._disposed && version === this._renderVersion) this.ready = true
        })
      }).catch(err => {
        if (!this._disposed && version === this._renderVersion && err.name !== 'RenderingCancelledException') this.error = true
      })
      return this._renderPromise
    }
  }
}
</script>

<style scoped>
.pdf-page{ margin: 0 auto 28px; }
.pdf-page:last-child{ margin-bottom: 0; }
.paper{ position: relative; background: #fff; box-shadow: 0 3px 14px rgba(31, 48, 66, .09); outline: 1px solid #e5e9ed; }
canvas{ display: block; }
figcaption{ padding-top: 14px; color: #87929e; text-align: center; font-size: 13px; line-height: 20px; }
.page-placeholder{ position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #8492a0; font-size: 14px; }
</style>



// WEBPACK FOOTER //
// src/components/kaifang/PdfPageCanvas.vue